__turbopack_context__.v({
  "close-icon": "_4-_OyG_close-icon",
  "toast-container": "_4-_OyG_toast-container",
  "toast-content": "_4-_OyG_toast-content",
  "toast-content-inner": "_4-_OyG_toast-content-inner",
  "toast-text": "_4-_OyG_toast-text",
});
